<template>
  <div class="l-block p-contentplans-suggest">
    <div class="l-block__header">
      <TitleSub icon="suggest" level="h2">
        <span class="title"
          >｢
          <span class="c-text--main">{{ keyword }}</span>
          ｣のサジェストマップ</span
        >
        <div v-if="suggest.data" class="p-contentplans-suggest__action">
          <ButtonDownloadSuggestMap
            :depth="depth"
            :keyword="keyword"
            :project="project"
            class="l-mr-2"
          >
            <span>CSVダウンロード</span>
          </ButtonDownloadSuggestMap>
          <Button
            variant="border"
            fsize="f12"
            :disabled="!isMoved"
            @click="zoomReset"
          >
            <Icon variant="return" :size="12" />
            <Icon variant="return_gn" :size="12" />
            戻す
          </Button>
          <div class="c-btn c-btn--zoom">
            <Button class="c-btn--zoom__out" @click="zoomOut">
              ズームアウト
            </Button>
            <Button class="c-btn--zoom__in" @click="zoomIn">
              ズームイン
            </Button>
          </div>
        </div>
      </TitleSub>
    </div>
    <GraphSuggestMap
      :period="period"
      :suggest="suggest"
      ref="graph"
      @zoomed="zoomed"
    />
  </div>
</template>

<script>
import Button from '@/components/Button';
import ButtonDownloadSuggestMap from '@/components/contentPlans/ButtonDownloadSuggestMap';
import GraphSuggestMap from '@/components/contentPlans/GraphSuggestMap';
import Icon from '@/components/Icon';
import TitleSub from '@/components/TitleSub';
import apiProjects from '@/api/projects';
import utils from '@/utils';
import axios from 'axios';

export default {
  props: ['createdAt', 'keyword', 'project'],
  components: {
    Button,
    ButtonDownloadSuggestMap,
    GraphSuggestMap,
    Icon,
    TitleSub
  },
  data() {
    return {
      depth: 2,
      period: [],
      suggest: {
        count: {
          keyword: 0,
          same: 0
        },
        data: null,
        source: null,
        timeoutId: null,
        isLoading: true
      },
      isMoved: false
    };
  },
  created() {
    if (!this.createdAt || !this.keyword) {
      this.$router.push({
        name: 'contentPlans'
      });
    }

    let untilDate = utils.getDateResetHours();
    untilDate.setDate(untilDate.getDate() - 1);
    let sinceDate = utils.getDateResetHours(untilDate);
    sinceDate.setMonth(sinceDate.getMonth() - 11);
    this.period = [sinceDate, untilDate];

    this.getSuggest();
  },
  destroyed() {
    clearTimeout(this.suggest.timeoutId);
    // 非同期通信をキャンセル
    if (this.suggest.source) {
      this.suggest.source.cancel();
    }
  },
  methods: {
    countChildren(obj) {
      let count = 0;
      if (obj.hasOwnProperty('children')) {
        count += obj.children.length;
        for (let i = 0; i < obj.children.length; i++) {
          count += this.countChildren(obj.children[i]);
        }
      }
      return count;
    },
    getSuggest() {
      let params = {
        depth: this.depth,
        keyword: this.keyword
      };
      this.suggest.source = axios.CancelToken.source();

      return apiProjects.contentPlans.suggestMap
        .get(
          params,
          this.auth.idToken,
          this.project.id,
          this.suggest.source.token
        )
        .then(response => {
          this.suggest.data = response.data;
          this.suggest.isLoading = false;

          let count = this.countChildren(this.suggest.data);
          if (this.suggest.count.keyword === count) {
            this.suggest.count.same++;
          } else {
            this.suggest.count.same = 0;
            this.suggest.count.keyword = count;
          }
          this.scheduleGetSuggest();
        })
        .catch(error => {
          this.suggest.isLoading = false;
          // 非同期処理をcancelした場合以外は再取得のタイマー設定
          if (!axios.isCancel(error)) {
            this.scheduleGetSuggest();
          }
        });
    },
    scheduleGetSuggest() {
      // キーワード数が同じ状態が5回続くまでは再取得を行う
      if (this.suggest.count.same < 5) {
        this.suggest.timeoutId = setTimeout(this.getSuggest, 10000);
      }
    },
    zoomed(zoom) {
      this.isMoved = zoom.x !== 0 || zoom.y !== 0 || zoom.k !== 1;
    },
    zoomIn() {
      this.$refs.graph.zoomIn();
    },
    zoomOut() {
      this.$refs.graph.zoomOut();
    },
    zoomReset() {
      this.$refs.graph.zoomReset();
    }
  }
};
</script>
